require('./../css/style.css');

import { } from "jquery-validation";
import { } from "jquery-validation-unobtrusive";

function initNewsletterForm(panelElement) {
    const form = panelElement.querySelector(".js-newsletter-form");
    const formSubmitBtn = form.querySelector(".js-newsletter-form__submit-btn");
    const formSuccessMessage = form.dataset.success;
    const formErrorMessage = form.dataset.error;
    const messageContainer = panelElement.querySelector(".js-newsletter-form__message");

    formSubmitBtn.addEventListener("click", (event) => {
        const isFormValid = $(form).valid();
        if (!isFormValid) {
            event.preventDefault();
        }
    });

    form.successCallback = () => {
        form.reset();
        form.style.display = "none";
        messageContainer.classList.add("success");
        messageContainer.innerHTML = formSuccessMessage;
    };

    form.errorCallback = () => {
        form.reset();
        messageContainer.classList.add("error");
        messageContainer.innerHTML = formErrorMessage;
    }
}

function initNewsletterPanel() {
    const newsletterPanels = document.querySelectorAll(".js-newsletter-panel");
    if (!newsletterPanels) {
        return;
    }
    const newsletterPanelsArray = Array.from(newsletterPanels);
    newsletterPanelsArray.forEach((newsletterPanel) => {
        initNewsletterForm(newsletterPanel);
    });
}

export default initNewsletterPanel;


// WEBPACK FOOTER //
// ./uPortal/Core/Panels/NewsletterPanel/Js/index.js